import { createSelector } from '@reduxjs/toolkit';
import { type TRootState } from 'lib/stores';

export const userListSelector = (state: TRootState) => state.user.userList;

export const currentUserSelector = (state: TRootState) =>
  state.user.currentUser;

export const isFetchingCurrentUserSelector = (state: TRootState) =>
  state.user.isFetchingCurrentUser;

export const currentUserIsAdminSelector = createSelector(
  currentUserSelector,
  user => Boolean(user?.username === 'admin_vpdt')
);

export const currentUserIsSuperAdminSelector = createSelector(
  currentUserSelector,
  user => Boolean(user?.username === 'admin')
);
